const data = {
  ar: [
    { id: "1", name: "مصر" },
    { id: "2", name: "السعودية" },
    { id: "3", name: "الولايات المتحدة" },
    { id: "4", name: "المملكة المتحدة" },
    { id: "5", name: "فرنسا" },
    { id: "6", name: "ألمانيا" },
    { id: "7", name: "اليابان" },
    { id: "8", name: "الصين" },
    { id: "9", name: "الهند" },
    { id: "10", name: "البرازيل" },
    { id: "11", name: "إيطاليا" },
    { id: "12", name: "إسبانيا" },
    { id: "13", name: "كندا" },
    { id: "14", name: "أستراليا" },
    { id: "15", name: "روسيا" },
    { id: "16", name: "كوريا" },
    { id: "17", name: "تركيا" },
    { id: "18", name: "السويد" },
    { id: "19", name: "النرويج" },
    { id: "20", name: "هولندا" },
    { id: "21", name: "أفغانستان" },
    { id: "22", name: "الجزائر" },
    { id: "23", name: "أنغولا" },
    { id: "24", name: "الأرجنتين" },
    { id: "25", name: "النمسا" },
    { id: "26", name: "بنغلاديش" },
    { id: "27", name: "بيلاروسيا" },
    { id: "28", name: "بلجيكا" },
    { id: "29", name: "بوليفيا" },
    { id: "30", name: "البوسنة والهرسك" },
    { id: "31", name: "كرواتيا" },
    { id: "32", name: "جمهورية التشيك" },
    { id: "33", name: "الدنمارك" },
    { id: "34", name: "الإكوادور" },
    { id: "35", name: "إثيوبيا" },
    { id: "36", name: "فنلندا" },
    { id: "37", name: "اليونان" },
    { id: "38", name: "المجر" },
    { id: "39", name: "إيران" },
    { id: "40", name: "العراق" },
    { id: "41", name: "أيرلندا" },
    { id: "42", name: "إسرائيل" },
    { id: "43", name: "جامايكا" },
    { id: "44", name: "الأردن" },
    { id: "45", name: "كازاخستان" },
    { id: "46", name: "كينيا" },
    { id: "47", name: "لبنان" },
    { id: "48", name: "ماليزيا" },
    { id: "49", name: "المغرب" },
    { id: "50", name: "نيجيريا" },
    { id: "51", name: "بولندا" },
    { id: "52", name: "البرتغال" },
    { id: "53", name: "قطر" },
    { id: "54", name: "رومانيا" },
    { id: "55", name: "سنغافورة" },
    { id: "56", name: "سلوفاكيا" },
    { id: "57", name: "سلوفينيا" },
    { id: "58", name: "جنوب إفريقيا" },
    { id: "59", name: "سريلانكا" },
    { id: "60", name: "تايلاند" },
    { id: "61", name: "تونس" },
    { id: "62", name: "أوكرانيا" },
    { id: "63", name: "أوزبكستان" },
    { id: "64", name: "فيتنام" },
    { id: "65", name: "ويلز" },
  ],
  en: [
    { id: "1", name: "Egypt" },
    { id: "2", name: "Saudi Arabia" },
    { id: "3", name: "United States" },
    { id: "4", name: "United Kingdom" },
    { id: "5", name: "France" },
    { id: "6", name: "Germany" },
    { id: "7", name: "Japan" },
    { id: "8", name: "China" },
    { id: "9", name: "India" },
    { id: "10", name: "Brazil" },
    { id: "11", name: "Italy" },
    { id: "12", name: "Spain" },
    { id: "13", name: "Canada" },
    { id: "14", name: "Australia" },
    { id: "15", name: "Russia" },
    { id: "16", name: "Korea" },
    { id: "17", name: "Turkey" },
    { id: "18", name: "Sweden" },
    { id: "19", name: "Norway" },
    { id: "20", name: "Netherlands" },
    { id: "21", name: "Afghanistan" },
    { id: "22", name: "Algeria" },
    { id: "23", name: "Angola" },
    { id: "24", name: "Argentina" },
    { id: "25", name: "Austria" },
    { id: "26", name: "Bangladesh" },
    { id: "27", name: "Belarus" },
    { id: "28", name: "Belgium" },
    { id: "29", name: "Bolivia" },
    { id: "30", name: "Bosnia and Herzegovina" },
    { id: "31", name: "Croatia" },
    { id: "32", name: "Czech Republic" },
    { id: "33", name: "Denmark" },
    { id: "34", name: "Ecuador" },
    { id: "35", name: "Ethiopia" },
    { id: "36", name: "Finland" },
    { id: "37", name: "Greece" },
    { id: "38", name: "Hungary" },
    { id: "39", name: "Iran" },
    { id: "40", name: "Iraq" },
    { id: "41", name: "Ireland" },
    { id: "42", name: "Israel" },
    { id: "43", name: "Jamaica" },
    { id: "44", name: "Jordan" },
    { id: "45", name: "Kazakhstan" },
    { id: "46", name: "Kenya" },
    { id: "47", name: "Lebanon" },
    { id: "48", name: "Malaysia" },
    { id: "49", name: "Morocco" },
    { id: "50", name: "Nigeria" },
    { id: "51", name: "Poland" },
    { id: "52", name: "Portugal" },
    { id: "53", name: "Qatar" },
    { id: "54", name: "Romania" },
    { id: "55", name: "Singapore" },
    { id: "56", name: "Slovakia" },
    { id: "57", name: "Slovenia" },
    { id: "58", name: "South Africa" },
    { id: "59", name: "Sri Lanka" },
    { id: "60", name: "Thailand" },
    { id: "61", name: "Tunisia" },
    { id: "62", name: "Ukraine" },
    { id: "63", name: "Uzbekistan" },
    { id: "64", name: "Vietnam" },
    { id: "65", name: "Wales" },
  ],
};
export default function Countries(lang: "ar" | "en") {
  return data[lang];
}
